import { useMediaQuery, useTheme } from '@mui/material';

export const useScreenSize = () => {
    const theme = useTheme();
    const xsUp = useMediaQuery(theme.breakpoints.up('xs'));
    const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
    const smUp = useMediaQuery(theme.breakpoints.up('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const mdUp = useMediaQuery(theme.breakpoints.up('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
    const xlUp = useMediaQuery(theme.breakpoints.up('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));
    return {
        xsUp,
        xsDown,
        smUp,
        smDown,
        mdUp,
        mdDown,
        lgUp,
        lgDown,
        xlUp,
        xlDown,
    };
};
